module.exports = __webpack_public_path__ + "img/valj.7e745b75.jpg";